/* eslint-disable react/prop-types */
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RolePrivateRoute from 'src/components/PrivateRotes/RolePrivateRoute';
import AgentsListView from 'src/views/catalog/AgentsListView';
import BrandsListView from './BrandsListView';
import EquipmentTypesListView from './EquipmentTypesListView';
import CompaniesListView from './CompaniesListView';
import InsurersListView from './InsurersListView';
import CatalogListView from './CatalogListView';
import IncidentsListView from './IncidentsListView';
import ServicesListView from './ServicesListView';
import TaxSystemView from './TaxSystemView';
import BillingConceptView from './BillingConcept';
import DenominationsView from './DenominationView';
import KinshipListView from './KinshipListView';
import IndustriesListView from './IndustriesListView';
import ModelsListView from './ModelsListView';
import AdministrativeRolesListView from './AdministrativeRolesListView';
import EconomicActivitiesView from './EconomicActivitiesListView';
import BanksListView from './BanksListView';
import LineOfBusinessListView from './LineOfBusinessListView';


const CatalogView = () => {
  return (
    <Routes>
      <Route index element={<RolePrivateRoute component={CatalogListView} />} />
      <Route path="agents" element={<RolePrivateRoute component={AgentsListView} />} />
      <Route path="companies" element={<RolePrivateRoute component={CompaniesListView} />} />
      <Route path="brands" element={<RolePrivateRoute component={BrandsListView} />} />
      <Route path="equipment-types" element={<RolePrivateRoute component={EquipmentTypesListView} />} />
      <Route path="insurers" element={<RolePrivateRoute component={InsurersListView} />} />
      <Route path="incidents" element={<RolePrivateRoute component={IncidentsListView} />} />
      <Route path="services" element={<RolePrivateRoute component={ServicesListView} />} />
      <Route path="tax-system" element={<RolePrivateRoute component={TaxSystemView} />} />
      <Route path="billing-concepts" element={<RolePrivateRoute component={BillingConceptView} />} />
      <Route path="denominations" element={<RolePrivateRoute component={DenominationsView} />} />
      <Route path="kinships" element={<RolePrivateRoute component={KinshipListView} />} />
      <Route path="lines-of-business" element={<RolePrivateRoute component={LineOfBusinessListView} />} />
      <Route path="industries" element={<RolePrivateRoute component={IndustriesListView} />} />
      <Route path="models/:id" element={<RolePrivateRoute component={ModelsListView} />} />
      <Route path="administrative-roles" element={<RolePrivateRoute component={AdministrativeRolesListView} />} />
      <Route path="economic-activities" element={<RolePrivateRoute component={EconomicActivitiesView} />} />
      <Route path="banks" element={<RolePrivateRoute component={BanksListView} />} />
    </Routes>
  );
};

export default CatalogView;
